/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AccountShortInfo} from '../models/AccountShortInfo';
import type {AccountSsoConnectionMetadata} from '../models/AccountSsoConnectionMetadata';
import type {Error} from '../models/Error';
import type {InheritSsoSettingsRequest} from '../models/InheritSsoSettingsRequest';
import type {SsoConnection} from '../models/SsoConnection';
import type {SsoConnectionName} from '../models/SsoConnectionName';
import type {SsoUserResetSettings} from '../models/SsoUserResetSettings';

export interface DeleteSsoSettings$Request {
    accountId: number;
}

export interface DeleteSsoSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const deleteSsoSettingsRequest = createAction<PayloadData<void, DeleteSsoSettings$Request>>('ACCOUNT_SINGLE_SIGN_ON__DELETE_SSO_SETTINGS__REQUEST');
export const deleteSsoSettingsSuccess = createAction<PayloadData<void, DeleteSsoSettings$Request>>('ACCOUNT_SINGLE_SIGN_ON__DELETE_SSO_SETTINGS__SUCCESS');
export const deleteSsoSettingsFailure = createAction<PayloadData<Error, DeleteSsoSettings$Request, true>>('ACCOUNT_SINGLE_SIGN_ON__DELETE_SSO_SETTINGS__FAILURE');

export const deleteSsoSettingsActions = [
    deleteSsoSettingsRequest,
    deleteSsoSettingsSuccess,
    deleteSsoSettingsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const deleteSsoSettings = (meta: DeleteSsoSettings$Request, config?: DeleteSsoSettings$Config) => {
    return {
        CALL_API: {
            types: deleteSsoSettingsActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/accounts/${meta.accountId}/sso/v2/inheritanse`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetAccountSsoConnection$Request {
    accountId: number;
}

export interface GetAccountSsoConnection$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountSsoConnectionRequest = createAction<PayloadData<void, GetAccountSsoConnection$Request>>('ACCOUNT_SINGLE_SIGN_ON__GET_ACCOUNT_SSO_CONNECTION__REQUEST');
export const getAccountSsoConnectionSuccess = createAction<PayloadData<SsoConnection, GetAccountSsoConnection$Request>>('ACCOUNT_SINGLE_SIGN_ON__GET_ACCOUNT_SSO_CONNECTION__SUCCESS');
export const getAccountSsoConnectionFailure = createAction<PayloadData<Error, GetAccountSsoConnection$Request, true>>('ACCOUNT_SINGLE_SIGN_ON__GET_ACCOUNT_SSO_CONNECTION__FAILURE');

export const getAccountSsoConnectionActions = [
    getAccountSsoConnectionRequest,
    getAccountSsoConnectionSuccess,
    getAccountSsoConnectionFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountSsoConnection = (meta: GetAccountSsoConnection$Request, config?: GetAccountSsoConnection$Config) => {
    return {
        CALL_API: {
            types: getAccountSsoConnectionActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/sso/v2`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetAccountSsoConnectionMetadata$Request {
    providerUrl?: string;
}

export interface GetAccountSsoConnectionMetadata$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountSsoConnectionMetadataRequest = createAction<PayloadData<void, GetAccountSsoConnectionMetadata$Request>>('ACCOUNT_SINGLE_SIGN_ON__GET_ACCOUNT_SSO_CONNECTION_METADATA__REQUEST');
export const getAccountSsoConnectionMetadataSuccess = createAction<PayloadData<AccountSsoConnectionMetadata, GetAccountSsoConnectionMetadata$Request>>('ACCOUNT_SINGLE_SIGN_ON__GET_ACCOUNT_SSO_CONNECTION_METADATA__SUCCESS');
export const getAccountSsoConnectionMetadataFailure = createAction<PayloadData<Error, GetAccountSsoConnectionMetadata$Request, true>>('ACCOUNT_SINGLE_SIGN_ON__GET_ACCOUNT_SSO_CONNECTION_METADATA__FAILURE');

export const getAccountSsoConnectionMetadataActions = [
    getAccountSsoConnectionMetadataRequest,
    getAccountSsoConnectionMetadataSuccess,
    getAccountSsoConnectionMetadataFailure
] as const;

/**
 * @param {string} [meta.providerUrl]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountSsoConnectionMetadata = (meta: GetAccountSsoConnectionMetadata$Request, config?: GetAccountSsoConnectionMetadata$Config) => {
    const TRANSPORT_GET_PARAMS = {
        providerUrl: meta.providerUrl,
    };
    return {
        CALL_API: {
            types: getAccountSsoConnectionMetadataActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/sso/v2/metadata`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetAccountSsoConnectionName$Request {
    accountId: number;
}

export interface GetAccountSsoConnectionName$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountSsoConnectionNameRequest = createAction<PayloadData<void, GetAccountSsoConnectionName$Request>>('ACCOUNT_SINGLE_SIGN_ON__GET_ACCOUNT_SSO_CONNECTION_NAME__REQUEST');
export const getAccountSsoConnectionNameSuccess = createAction<PayloadData<SsoConnectionName, GetAccountSsoConnectionName$Request>>('ACCOUNT_SINGLE_SIGN_ON__GET_ACCOUNT_SSO_CONNECTION_NAME__SUCCESS');
export const getAccountSsoConnectionNameFailure = createAction<PayloadData<Error, GetAccountSsoConnectionName$Request, true>>('ACCOUNT_SINGLE_SIGN_ON__GET_ACCOUNT_SSO_CONNECTION_NAME__FAILURE');

export const getAccountSsoConnectionNameActions = [
    getAccountSsoConnectionNameRequest,
    getAccountSsoConnectionNameSuccess,
    getAccountSsoConnectionNameFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountSsoConnectionName = (meta: GetAccountSsoConnectionName$Request, config?: GetAccountSsoConnectionName$Config) => {
    return {
        CALL_API: {
            types: getAccountSsoConnectionNameActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/sso/v2/name`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetUserResetSettingsSSO$Request {
    accountId: number;
}

export interface GetUserResetSettingsSSO$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserResetSettingsSSORequest = createAction<PayloadData<void, GetUserResetSettingsSSO$Request>>('ACCOUNT_SINGLE_SIGN_ON__GET_USER_RESET_SETTINGS_SSO__REQUEST');
export const getUserResetSettingsSSOSuccess = createAction<PayloadData<SsoUserResetSettings, GetUserResetSettingsSSO$Request>>('ACCOUNT_SINGLE_SIGN_ON__GET_USER_RESET_SETTINGS_SSO__SUCCESS');
export const getUserResetSettingsSSOFailure = createAction<PayloadData<Error, GetUserResetSettingsSSO$Request, true>>('ACCOUNT_SINGLE_SIGN_ON__GET_USER_RESET_SETTINGS_SSO__FAILURE');

export const getUserResetSettingsSSOActions = [
    getUserResetSettingsSSORequest,
    getUserResetSettingsSSOSuccess,
    getUserResetSettingsSSOFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserResetSettingsSSO = (meta: GetUserResetSettingsSSO$Request, config?: GetUserResetSettingsSSO$Config) => {
    return {
        CALL_API: {
            types: getUserResetSettingsSSOActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/sso/v2/reset-period`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface InheritSsoSettings$Request {
    accountId: number;
    inheritSsoSettingsRequest: InheritSsoSettingsRequest;
}

export interface InheritSsoSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const inheritSsoSettingsRequest = createAction<PayloadData<void, InheritSsoSettings$Request>>('ACCOUNT_SINGLE_SIGN_ON__INHERIT_SSO_SETTINGS__REQUEST');
export const inheritSsoSettingsSuccess = createAction<PayloadData<SsoConnection, InheritSsoSettings$Request>>('ACCOUNT_SINGLE_SIGN_ON__INHERIT_SSO_SETTINGS__SUCCESS');
export const inheritSsoSettingsFailure = createAction<PayloadData<Error, InheritSsoSettings$Request, true>>('ACCOUNT_SINGLE_SIGN_ON__INHERIT_SSO_SETTINGS__FAILURE');

export const inheritSsoSettingsActions = [
    inheritSsoSettingsRequest,
    inheritSsoSettingsSuccess,
    inheritSsoSettingsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {InheritSsoSettingsRequest} meta.inheritSsoSettingsRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const inheritSsoSettings = (meta: InheritSsoSettings$Request, config?: InheritSsoSettings$Config) => {
    return {
        CALL_API: {
            types: inheritSsoSettingsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/accounts/${meta.accountId}/sso/v2/inheritanse`,
            TRANSPORT_REQUEST_BODY: meta.inheritSsoSettingsRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveUserResetSettingsSSO$Request {
    accountId: number;
    ssoUserResetSettings: SsoUserResetSettings;
}

export interface SaveUserResetSettingsSSO$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveUserResetSettingsSSORequest = createAction<PayloadData<void, SaveUserResetSettingsSSO$Request>>('ACCOUNT_SINGLE_SIGN_ON__SAVE_USER_RESET_SETTINGS_SSO__REQUEST');
export const saveUserResetSettingsSSOSuccess = createAction<PayloadData<void, SaveUserResetSettingsSSO$Request>>('ACCOUNT_SINGLE_SIGN_ON__SAVE_USER_RESET_SETTINGS_SSO__SUCCESS');
export const saveUserResetSettingsSSOFailure = createAction<PayloadData<Error, SaveUserResetSettingsSSO$Request, true>>('ACCOUNT_SINGLE_SIGN_ON__SAVE_USER_RESET_SETTINGS_SSO__FAILURE');

export const saveUserResetSettingsSSOActions = [
    saveUserResetSettingsSSORequest,
    saveUserResetSettingsSSOSuccess,
    saveUserResetSettingsSSOFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {SsoUserResetSettings} meta.ssoUserResetSettings
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveUserResetSettingsSSO = (meta: SaveUserResetSettingsSSO$Request, config?: SaveUserResetSettingsSSO$Config) => {
    return {
        CALL_API: {
            types: saveUserResetSettingsSSOActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/accounts/${meta.accountId}/sso/v2/reset-period`,
            TRANSPORT_REQUEST_BODY: meta.ssoUserResetSettings,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SearchSsoSettingsDonor$Request {
    accountId: number;
    accountName?: string;
}

export interface SearchSsoSettingsDonor$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const searchSsoSettingsDonorRequest = createAction<PayloadData<void, SearchSsoSettingsDonor$Request>>('ACCOUNT_SINGLE_SIGN_ON__SEARCH_SSO_SETTINGS_DONOR__REQUEST');
export const searchSsoSettingsDonorSuccess = createAction<PayloadData<Array<AccountShortInfo>, SearchSsoSettingsDonor$Request>>('ACCOUNT_SINGLE_SIGN_ON__SEARCH_SSO_SETTINGS_DONOR__SUCCESS');
export const searchSsoSettingsDonorFailure = createAction<PayloadData<Error, SearchSsoSettingsDonor$Request, true>>('ACCOUNT_SINGLE_SIGN_ON__SEARCH_SSO_SETTINGS_DONOR__FAILURE');

export const searchSsoSettingsDonorActions = [
    searchSsoSettingsDonorRequest,
    searchSsoSettingsDonorSuccess,
    searchSsoSettingsDonorFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {string} [meta.accountName]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const searchSsoSettingsDonor = (meta: SearchSsoSettingsDonor$Request, config?: SearchSsoSettingsDonor$Config) => {
    const TRANSPORT_GET_PARAMS = {
        accountName: meta.accountName,
    };
    return {
        CALL_API: {
            types: searchSsoSettingsDonorActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/sso/v2/inheritanse`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdateAccountSsoConnection$Request {
    accountId: number;
    ssoConnection: SsoConnection;
}

export interface UpdateAccountSsoConnection$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateAccountSsoConnectionRequest = createAction<PayloadData<void, UpdateAccountSsoConnection$Request>>('ACCOUNT_SINGLE_SIGN_ON__UPDATE_ACCOUNT_SSO_CONNECTION__REQUEST');
export const updateAccountSsoConnectionSuccess = createAction<PayloadData<void, UpdateAccountSsoConnection$Request>>('ACCOUNT_SINGLE_SIGN_ON__UPDATE_ACCOUNT_SSO_CONNECTION__SUCCESS');
export const updateAccountSsoConnectionFailure = createAction<PayloadData<Error, UpdateAccountSsoConnection$Request, true>>('ACCOUNT_SINGLE_SIGN_ON__UPDATE_ACCOUNT_SSO_CONNECTION__FAILURE');

export const updateAccountSsoConnectionActions = [
    updateAccountSsoConnectionRequest,
    updateAccountSsoConnectionSuccess,
    updateAccountSsoConnectionFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {SsoConnection} meta.ssoConnection
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateAccountSsoConnection = (meta: UpdateAccountSsoConnection$Request, config?: UpdateAccountSsoConnection$Config) => {
    return {
        CALL_API: {
            types: updateAccountSsoConnectionActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/accounts/${meta.accountId}/sso/v2`,
            TRANSPORT_REQUEST_BODY: meta.ssoConnection,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

